module.exports = __webpack_public_path__ + "static/media/WIFI.a6041713.svg";